import axios from "axios";
import { GOOGLE_API_KEY } from "../constants";
const GOOGLE_GEOLOCATION_URL =
  "https://www.googleapis.com/geolocation/v1/geolocate?key=" + GOOGLE_API_KEY;
const GOOGLE_GEOCODE_URL =
  "https://maps.googleapis.com/maps/api/geocode/json?key=" + GOOGLE_API_KEY;

const getGeoLocation = async () => {
  return axios(GOOGLE_GEOLOCATION_URL, {
    method: "POST",
  })
    .then(async (response) => {
      if (response.data !== undefined) {
        var geoAddressRes = await getGeoAddress(response.data.location.lat, response.data.location.lng);
        geoAddressRes.latitude = response.data.location.lat;
        geoAddressRes.longitude = response.data.location.lng;
        
        return geoAddressRes;
      } else {
        return {};
      }
    })
    .catch((error) => {
      return {};
    });
};

const getGeoAddress = (lat, lng) => {
  var url = `${GOOGLE_GEOCODE_URL}&latlng=${lat},${lng}`;
  return axios(url, {
    method: "POST",
  })
    .then((response) => {
      if(response.status === 200 && response.data.status === 'OK') {  
        var address = getAddressParts(response.data.results);
        return address;
      }
    })
    .catch((error) => {
      return {};
    });
};

const getAddressParts = (results) => {
  var address = [];
  results.forEach( function(obj) {
    obj.address_components.forEach( function(el) {
      if (el.types.indexOf("country") > -1) {
        address[el.types[0]] = el.short_name;
      } else {
        address[el.types[0]] = el.long_name;
      }
    });
  });

  return address;

}

export default getGeoLocation;
